import React from 'react';
import {CalendarPlus, MoonStars} from "@phosphor-icons/react";

const IconAddScheduled = (props) => (
    <CalendarPlus {...props}/>
);

export default IconAddScheduled;